import script from "./AgenteAi.vue?vue&type=script&setup=true&lang=js"
export * from "./AgenteAi.vue?vue&type=script&setup=true&lang=js"

import "./AgenteAi.vue?vue&type=style&index=0&id=3c6f9399&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c6f9399"]])

export default __exports__